<template>
  <div id="perfil">
    <!-- MODAL -->
    <div
      class="modal fade"
      id="modal_perfil"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content container_admin">
          <label class="dato ml-3"><b>Mi Perfil</b></label>
          <div class="modal-body row">
            <div class="col-md-6">
              <label class="color_letra">Nombres</label>
              <input
                v-model="c_nombre"
                type="text"
                class="form-control Mayus boton_texto"
                placeholder="Nombre Usuario."
                required
              />
            </div>
            <div class="col-md-6">
              <label class="color_letra">Apellidos</label>
              <input
                v-model="c_apellido"
                type="text"
                class="form-control Mayus boton_texto"
                placeholder="Apellido Usuario."
                required
              />
            </div>
            <div class="col-md-6 mt-4">
              <label class="color_letra">N° de Identificación</label>
              <input
                v-model="c_cedula"
                type="text"
                class="form-control Mayus boton_texto"
                placeholder="Cedula Usuario."
                required
              />
            </div>
            <div class="col-md-6 mt-4">
              <label class="color_letra">Cargo</label>
              <input
                v-model="c_cargo"
                type="text"
                class="form-control Mayus boton_texto"
                placeholder="Cargo Usuario."
                required
              />
            </div>
            <div class="col-md-6 mt-4">
              <label class="color_letra">Correo</label>
              <input
                v-model="c_correo"
                type="text"
                class="form-control boton_texto"
                placeholder="Correo Usuario."
                required
              />
            </div>
            <div class="col-md-6 mt-4">
              <label class="color_letra"
                >Número de Celular o Teléfono Fijo</label
              >
              <input
                v-model="c_telefono"
                type="text"
                class="form-control Mayus boton_texto"
                placeholder="Telefono del Usuario."
                required
              />
            </div>
            <div class="col-md-5 mt-4">
              <label class="color_letra">Estado</label>
              <div v-if="c_estado == 0">
                <button type="button" class="btn btn-primary">Activo</button>
              </div>
              <div v-if="c_estado == 1">No Activo</div>
            </div>
            <div class="col-md-12 mt-4">
              <label class="color_letra">PRIVILEGIOS</label>
            </div>
            <div class="col-md-12 mt-2">
              <label class="color_letra">Administración</label>
            </div>
            <div class="col-md-1"></div>
            <div class="col-md-1">
              <label class="color_letra">Registro Cliente</label>
              <ul id="example-1">
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_cliente.crear
                  "
                >
                  Crear
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_cliente.editar
                  "
                >
                  Editar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_cliente
                      .eliminar
                  "
                >
                  Eliminar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_cliente.ver
                  "
                >
                  Ver
                </li>
              </ul>
            </div>
            <div class="col-md-1 ml-4">
              <label class="color_letra">Registro Proceso</label>
              <ul id="example-1">
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_proceso.crear
                  "
                >
                  Crear
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_proceso.editar
                  "
                >
                  Editar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_proceso
                      .eliminar
                  "
                >
                  Eliminar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_proceso.ver
                  "
                >
                  Ver
                </li>
              </ul>
            </div>
            <div class="col-md-1 ml-4">
              <label class="color_letra">Registro Peligro</label>
              <ul id="example-1">
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_peligro.crear
                  "
                >
                  Crear
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_peligro.editar
                  "
                >
                  Editar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_peligro
                      .eliminar
                  "
                >
                  Eliminar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_peligro.ver
                  "
                >
                  Ver
                </li>
              </ul>
            </div>
            <div class="col-md-1 ml-4">
              <label class="color_letra">Efectos Posibles</label>
              <ul id="example-1">
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_efecto_posible
                      .crear
                  "
                >
                  Crear
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_efecto_posible
                      .editar
                  "
                >
                  Editar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_efecto_posible
                      .eliminar
                  "
                >
                  Eliminar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_efecto_posible
                      .ver
                  "
                >
                  Ver
                </li>
              </ul>
            </div>
            <div class="col-md-1 ml-4">
              <label class="color_letra">Control y media</label>
              <ul id="example-1">
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_control_medida
                      .crear
                  "
                >
                  Crear
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_control_medida
                      .editar
                  "
                >
                  Editar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_control_medida
                      .eliminar
                  "
                >
                  Eliminar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_control_medida
                      .ver
                  "
                >
                  Ver
                </li>
              </ul>
            </div>
            <div class="col-md-1 ml-4">
              <label class="color_letra">Registrar Usuario</label>
              <ul id="example-1">
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_usuario.crear
                  "
                >
                  Crear
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_usuario.editar
                  "
                >
                  Editar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_usuario
                      .eliminar
                  "
                >
                  Eliminar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_usuario.ver
                  "
                >
                  Ver
                </li>
              </ul>
            </div>
            <div class="col-md-1 ml-4">
              <label class="color_letra">Registrar Regionales</label>
              <ul id="example-1">
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_regional.crear
                  "
                >
                  Crear
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_regional
                      .editar
                  "
                >
                  Editar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_regional
                      .eliminar
                  "
                >
                  Eliminar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_admin_registro_regional.ver
                  "
                >
                  Ver
                </li>
              </ul>
            </div>
            <div class="col-md-5 mt-4">
              <label class="color_letra">Matriz</label>
              <ul id="example-1">
                <li
                  v-show="$store.state.global_privilegio_matriz_peligro.crear"
                >
                  Crear
                </li>
                <li
                  v-show="$store.state.global_privilegio_matriz_peligro.editar"
                >
                  Editar
                </li>
                <li
                  v-show="
                    $store.state.global_privilegio_matriz_peligro.eliminar
                  "
                >
                  Eliminar
                </li>
                <li v-show="$store.state.global_privilegio_matriz_peligro.ver">
                  Ver
                </li>
              </ul>
            </div>
            <div class="col-md-6 mt-4">
              <label class="color_letra">Consulta</label>
              <li v-show="$store.state.global_privilegio_consulta.ver">Ver</li>
              <li v-show="$store.state.global_privilegio_consulta.excel">
                Descargar Excel
              </li>
              <li v-show="$store.state.global_privilegio_consulta.pdf">
                Descargar PDF
              </li>
              <li>Fecha desde {{ c_fecha_inicial }}</li>
              <li>hasta {{ c_fecha_fin }}</li>
            </div>
            <div class="col-md-12 mt-4">
              <label class="color_letra">Tipo de Datos</label>
            </div>
            <div class="col-md-4">
              <label class="color_letra">Regionales</label>
              <div v-if="c_regional == 'Todas las regiones'">
                <h6>
                  Todas las regionales con sus departamentos y municipios
                  seleccionados
                </h6>
              </div>
              <div v-if="c_regional == 'Regionales a seleccionar'">
                <ul id="example-1">
                  <li v-for="item1 in c_regional_seleccionada" :key="item1">
                    {{ item1 }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-4">
              <label class="color_letra">Departamentos</label>
              <ul id="example-1">
                <li v-for="item2 in c_departamentos" :key="item2">
                  {{ item2 }}
                </li>
              </ul>
            </div>
            <div class="col-md-4">
              <label class="color_letra">Municipios</label>
              <ul id="example-1">
                <li v-for="item3 in c_municipios" :key="item3">
                  {{ item3 }}
                </li>
              </ul>
            </div>
            <div class="col-md-12 mt-4">
              <p>
                <a
                  class="btn btn-outline-secondary"
                  data-toggle="collapse"
                  href="#collapseExample"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                >
                  Cambiar Contraseña
                </a>
              </p>
              <div class="collapse" id="collapseExample">
                <div class="card card-body">
                  <label class="color_letra mt-3">Contraseña Anterior</label>
                  <input
                    v-model="contraseña_anterior"
                    id="input_pass"
                    type="password"
                    class="form-control boton_texto"
                  />

                  <label class="color_letra mt-3">Contraseña Nueva</label>
                  <input type="password" class="form-control boton_texto" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn boton_cancelar"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button type="button" class="btn boton_guardar">
              Actualizar Datos
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "./../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "perfil",

  data() {
    return {
      c_nombre: "",
      c_apellido: "",
      c_cedula: "",
      c_cargo: "",
      c_correo: "",
      c_telefono: "",
      c_estado: "",
      c_fecha_inicial: "",
      c_fecha_fin: "",
      c_regional: "",
      c_regional_seleccionada: [],
      c_departamentos: [],
      c_municipios: [],
      contraseña_anterior: "",
    };
  },
  created() {
    if (!this.$store.state.email) {
      this.$router.replace("/");
      return;
    }
    this.consultar();
  },
  methods: {
    // FUNCIÓN PARA CONSULTAR USUARIO
    consultar() {
      NProgress.start();
      var docRef = db.collection("usuarios").doc(this.$store.state.id);
      docRef.get().then((doc) => {
        if (doc.exists) {
          this.c_key = `${doc.id}`;
          this.c_nombre = `${doc.data().u_nombre_usuario}`;
          this.c_apellido = `${doc.data().u_apellido}`;
          this.c_cedula = `${doc.data().u_cedula}`;
          this.c_cargo = `${doc.data().u_cargo}`;
          this.c_correo = `${doc.data().u_correo}`;
          this.c_telefono = `${doc.data().u_telefono}`;
          this.c_estado = `${doc.data().u_estado}`;
          this.c_fecha_inicial = doc.data().u_rango_fecha_inicio;
          this.c_fecha_fin = doc.data().u_rango_fecha_fin;
          this.c_regional = doc.data().u_regional;
          this.c_regional_seleccionada = doc.data().u_regionales_seleccionadas;
          this.c_departamentos = doc.data().u_departamentos_seleccionados;
          this.c_municipios = doc.data().u_municipio_seleccionados;
        }
        $("#modal_perfil").modal("show");
      });
      NProgress.done();
      NProgress.remove();
    },
  },
};
</script>